import type { ReactElement } from "react";

export const NameMicBlack = ({ className = "" }: { className?: string }): ReactElement => {
  // not implemented
  return <></>;
  /*
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <mask id="mask0_1040_11481" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1040_11481)">
        <path
          d="M9.99998 11.6666C9.29273 11.6666 8.6923 11.4199 8.19871 10.9263C7.70512 10.4327 7.45833 9.83225 7.45833 9.125V4.08333C7.45833 3.37608 7.70512 2.77566 8.19871 2.28206C8.6923 1.78848 9.29273 1.54169 9.99998 1.54169C10.7072 1.54169 11.3077 1.78848 11.8012 2.28206C12.2948 2.77566 12.5416 3.37608 12.5416 4.08333V9.125C12.5416 9.83225 12.2948 10.4327 11.8012 10.9263C11.3077 11.4199 10.7072 11.6666 9.99998 11.6666ZM9.08333 17.1042V15.3157C7.69017 15.1586 6.5056 14.59 5.52964 13.6098C4.55369 12.6295 3.96902 11.4401 3.77564 10.0416C3.72544 9.80874 3.7858 9.59774 3.95673 9.40865C4.12767 9.21955 4.34348 9.125 4.60417 9.125C4.85096 9.125 5.0689 9.21394 5.258 9.39181C5.4471 9.5697 5.56835 9.78204 5.62177 10.0288C5.82903 11.0769 6.34426 11.9314 7.16744 12.5921C7.99062 13.2529 8.9348 13.5833 9.99998 13.5833C11.0652 13.5833 12.0093 13.2529 12.8325 12.5921C13.6557 11.9314 14.1709 11.0769 14.3782 10.0288C14.4455 9.78204 14.5702 9.5697 14.7524 9.39181C14.9345 9.21394 15.149 9.125 15.3958 9.125C15.6565 9.125 15.8723 9.21608 16.0432 9.39823C16.2142 9.58038 16.2745 9.79486 16.2243 10.0416C16.0309 11.4263 15.4428 12.6108 14.4599 13.5953C13.477 14.5798 12.282 15.1533 10.875 15.3157V17.1042C10.875 17.351 10.7874 17.562 10.6121 17.7372C10.4369 17.9124 10.2259 18 9.97914 18C9.73235 18 9.52135 17.9124 9.34614 17.7372C9.17094 17.562 9.08333 17.351 9.08333 17.1042Z"
          fill="black"
        />
      </g>
    </svg>
  );
  */
};
